// import { StorageService } from "@/core/index";
import { StorageService } from "@/core/services/storage.service";
import Storage from "@/core/services/storage";
import { message } from "ant-design-vue";
import Cookies from "js-cookie";
let lockr = new Storage("cpms_");
import { analysInfo } from "@/core/yiguan-sdk";
import { setUserProperty } from "@/core/yiguan-sdk/utils";
import { LoginService } from "@/views/login/login.service";
import { WorkbenchService } from "@/views/platform-electronic-visa/workbench/index.service";

export type User = {
  userInfo: any;
  userInfoAccessToken: any;
  permissions: Array<object>;
  activeFirstMenu: Object;
  activeSecondMenu: Object;
  activeRoutePath: string;
  originalMenuObj: Object;
  parentChildrenObj: Object;
  leftMenus: Array<Object>;
  childrenMenus: Array<string>;
  firstMenuName: string;
  firstPath: string;
  canAddUserFlag: Boolean;
  isMessageCenter: string;
  buttons: Object;
  hideRoute: Boolean;
  zIndex: number;
  windowSize: {
    rightWidth: number;
    rightHeight: number;
    height: number;
    tableHeight: number;
  };
  openSystemInfo: any;
  belongSystem: number;
  authUserStatus: number;
  authCompanyStatus: number;
};
export default {
  namespaced: true,
  state: {
    hideRoute: false,
    userInfo: lockr.get("cpms_userInfo") || {},
    userInfoAccessToken: lockr.get("cpms_userInfoAccessToken") || {},
    buttons: {},
    permissions: lockr.get("permissions") || [],
    activeFirstMenu: lockr.get("activeFirstMenu") || {},
    activeSecondMenu: lockr.get("activeSecondMenu") || {},
    activeRoutePath: lockr.get("activeRoutePath") || "",
    originalMenuObj: {},
    parentChildrenObj: lockr.get("parentChildrenObj") || {},
    leftMenus: [],
    childrenMenus: [],
    firstMenuName: "",
    firstPath: "",
    canAddUserFlag: lockr.get("canAddUserFlag") || false,
    isMessageCenter: false,
    zIndex: 100,
    windowSize: StorageService?.get("__windowSize") || {
      rightWidth: 0,
      rightHeight: 0,
      height: 0,
      tableHeight: 0,
    },
    openSystemInfo: lockr.get("cpms_openSystemInfo") || {},
    belongSystem: lockr.get("belongSystem") || 0,
    authUserStatus: lockr.get("authUserStatus") || 0,
    authCompanyStatus: lockr.get("authCompanyStatus") || 0,
  },
  mutations: {
    SET_hideRoute: function (state, hideRoute) {
      state.hideRoute = hideRoute;
    },
    SET_zIndex: function (state, zIndex) {
      state.zIndex = zIndex;
    },
    SET_leftMenus: function (state, leftMenus) {
      state.leftMenus = leftMenus;
    },
    SET_BUTTONS: function (state, arr) {
      state.buttons = arr;
    },
    SET_parentChildrenObj: function (state, parentChildrenObj) {
      state.parentChildrenObj = parentChildrenObj;
      //lockr.set("parentChildrenObj", parentChildrenObj);
    },
    SET_originalMenuObj: function (state, originalMenuObj) {
      state.originalMenuObj = originalMenuObj;
      //lockr.set("originalMenuObj", originalMenuObj);
    },
    SET_activeRoutePath: function (state, activeRoutePath) {
      state.activeRoutePath = activeRoutePath;
      lockr.set("activeRoutePath", activeRoutePath);
    },
    SET_activeSecondMenu: function (state, activeSecondMenu) {
      state.activeSecondMenu = activeSecondMenu;
      // lockr.set("activeSecondMenu", activeSecondMenu);
    },
    SET_activeFirstMenu: function (state, activeFirstMenu) {
      state.activeFirstMenu = activeFirstMenu;
      // lockr.set("activeFirstMenu", activeFirstMenu);
    },
    SET_CANADDUSER: function (state, canAddUserFlag) {
      state.canAddUserFlag = canAddUserFlag;
      lockr.set("canAddUserFlag", canAddUserFlag);
      Cookies.set("cpms_canAddUserFlag", canAddUserFlag);
    },
    SET_INFO: function (state, userInfo) {
      state.userInfo = userInfo;
      const property = {
        userId: userInfo.userId,
        zuhu_id: userInfo.tenantId,
        zuhu_name: userInfo.company,
        bumen_name: userInfo.departmentName,
      };

      lockr.set("cpms_userInfo", userInfo);
      // userInfo.userId &&
      //   setUserProperty(property, { user_name: userInfo.realName, user_account: userInfo.userId });
    },
    SET_INFOACCESSTOKEN: function (state, userInfo) {
      state.userInfoAccessToken = userInfo;

      const roleName: string = (
        userInfo.roles?.map((ele) => {
          return ele.roleName;
        }) || []
      ).join(",");
      // analysInfo.AnalysysAgent?.registerSuperProperties("juese_name", roleName);

      lockr.set("cpms_userInfoAccessToken", userInfo);
    },
    CLEAR_INFOACCESSTOKEN: function (state, userInfo) {
      state.userInfoAccessToken = {};
      lockr.removeBatch("cpms_userInfoAccessToken");
    },
    SET_OPENSYSTEMINFO: function (state, openSystemInfo) {
      state.openSystemInfo = openSystemInfo;
      lockr.set("openSystemInfo", openSystemInfo);
    },
    SET_BELONGSYSTEM: function (state, belongSystem) {
      state.belongSystem = belongSystem;
      lockr.set("belongSystem", belongSystem);
    },
    SET_AUTHSTATUS: function (state, { authUserStatus, authCompanyStatus }) {
      state.authUserStatus = authUserStatus;
      state.authCompanyStatus = authCompanyStatus;
      lockr.set("authUserStatus", authUserStatus);
      lockr.set("authCompanyStatus", authCompanyStatus);
    },
    SET_PERMISSIONS: function (state, permissions) {
      state.permissions = permissions;
      // lockr.set("permissions", permissions);
    },
    SET_CHILDRENMENUS: function (state, childrenMenus) {
      state.childrenMenus = childrenMenus;
    },
    SET_FIRSTMENUNAME: function (state, firstMenuName) {
      state.firstMenuName = firstMenuName;
    },
    SET_FIRSTPATH: function (state, firstPath) {
      state.firstPath = firstPath;
    },
    SET_ISMESSAGE: function (state, isMessageCenter) {
      state.isMessageCenter = isMessageCenter;
    },
    SET_WINDOWSIZE: function (state, size) {
      state.windowSize = size;
      StorageService.set("__windowSize", size);
    },
  },
  actions: {
    GET_AUTHSTATUS({ state, commit }) {
      const tenantId = state.userInfoAccessToken.userResp.tenantId;
      const userId = state.userInfoAccessToken.userResp.tenantUserId;
      return new Promise((resolve, reject) => {
        // 查询租户开通的应用
        const { run } = WorkbenchService.verifyShiMing();
        const params = {
          list: [
            { type: 1, userId },
            { type: 2, customerTenantId: tenantId },
          ],
        };
        run(params)
          .then((res) => {
            console.log("认证状态:", res);
            // 个人Status： 0：未激活；1：未认证； 2：审核通过；3：已提交待审核；4：审核不通过;
            // 企业status：0：未认证；1：管理员资料已提交；2：企业基本资料(没有申请表)已提交；3：已提交待审核；4：审核通过；5：审核不通过；6人工初审通过
            if (res.respCode == "0000" && res.data?.list?.length) {
              const userRes = res.data.list.find((item) => item.userId == userId);
              const tenantRes = res.data.list.find((item) => item.customerTenantId == tenantId);
              commit("SET_AUTHSTATUS", {
                authUserStatus: userRes?.returnStatus || 0,
                authCompanyStatus: tenantRes?.returnStatus || 0,
              });
              resolve(true);
            } else {
              commit("SET_AUTHSTATUS", {
                authUserStatus: 0,
                authCompanyStatus: 0,
              });
              resolve(true);
            }
          })
          .catch((err) => {
            message.error(err.respDesc);
            reject();
          });
      });
    },
    GET_OPENSYSTEMINFO({ state, commit }, { tenantId, loginVerifySignature }) {
      return new Promise((resolve, reject) => {
        // 查询租户开通的应用
        // const { run: runPlatform } = LoginService.getTenantApplicationByTenantId();
        // runPlatform({ tenantId, loginVerifySignature })
        //   .then((res: any) => {
        //     if (res.respCode === "0000") {
        //       commit("SET_OPENSYSTEMINFO", res.data);
        //       // if (state.belongSystem) {
        //       //   commit("SET_BELONGSYSTEM", state.belongSystem);
        //       //   return resolve(true);
        //       // }
        //       console.log("state.belongSystem", state.belongSystem);
        //       if (res.data.partnerOneApp && res.data.partnerOneMenu) {
        //         commit("SET_BELONGSYSTEM", 1);
        //         resolve(true);
        //       } else if (res.data.electronicVisaApp && res.data.electronicVisaMenu) {
        //         commit("SET_BELONGSYSTEM", 2);
        //         resolve(true);
        //       } else {
        //         message.error("暂无访问权限，请联系您企业的系统管理员开通应用！");
        //         resolve(false);
        //       }
        //     } else {
        //       message.error(res.respDesc);
        //       reject();
        //     }
        //   })
        //   .catch((err) => {
        //     message.error(err.respDesc);true
        //     reject();
        //   });
         
           commit("SET_BELONGSYSTEM", 1);
           return resolve(true);
      });
    },
  },
  getters: {},
};
